// Shared metadata for the Library — kept in sync with the backend enum values.

export const INDUSTRIES = [
    { slug: "cafes-and-eateries", label: "Cafés & Eateries", emoji: "☕" },
    { slug: "trades-and-builders", label: "Trades & Builders", emoji: "🔨" },
    { slug: "beauty-and-wellness", label: "Beauty & Wellness", emoji: "💆" },
    { slug: "retail-and-boutiques", label: "Retail & Boutiques", emoji: "🛍️" },
    { slug: "health-and-fitness", label: "Health & Fitness", emoji: "🏋️" },
    { slug: "professional-services", label: "Professional Services", emoji: "💼" },
    { slug: "home-services", label: "Home Services", emoji: "🏡" },
    { slug: "creative-and-freelance", label: "Creative & Freelance", emoji: "🎨" },
];

export const CATEGORIES = [
    { slug: "tips-and-tricks", label: "Tips & Tricks" },
    { slug: "ai-for-small-biz", label: "AI for small biz" },
    { slug: "tax-nz", label: "Tax & compliance (NZ)" },
    { slug: "tax-au", label: "Tax & compliance (AU)" },
    { slug: "discounts-and-memberships", label: "Discounts & memberships" },
    { slug: "marketing-updates", label: "Marketing updates" },
];

export function findIndustry(slug) {
    return INDUSTRIES.find((i) => i.slug === slug);
}

export function findCategory(slug) {
    return CATEGORIES.find((c) => c.slug === slug);
}

export function slugify(text) {
    return (text || "")
        .toLowerCase()
        .trim()
        .replace(/['"]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}
